import { Component } from 'react';
import { userData } from '../../Redux/services/generalService';
import service from '../../core/service';
import routes from '../../core/routes';
import { AppConstants } from '../../core/constants';
import { toast } from 'react-toastify';
import * as yup from 'yup'

interface IProps {
  userData: any,
  dispatch?: any,
}
interface IState {
  showAgentUpdateModal: boolean,
  newAgentCode: any,
  currentAgentCode: any,
  loadingUpdate:boolean;
}
export class PreviewController extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
  }
  state: IState = {
    showAgentUpdateModal: false,
    newAgentCode: null,
  currentAgentCode: null,
  loadingUpdate:false
  };
  getProfile = (queryParam?: string | null) => {
    return async  (dispatch: any) => {
        try {
            const response = await service.User.profile();
            const profileData = response?.data?.data;
            if (response) {
                dispatch(userData(response?.data?.data));
              const agent = profileData.agent;

      const hashAgentCode = agent?.hash_agent_code || null;
      if (queryParam) {
        if (!hashAgentCode) {
          await this.props.dispatch(this.updateProfile(queryParam))
        } else if (hashAgentCode !== queryParam) {
          this.setState({
            showAgentUpdateModal: true,
            currentAgentCode: hashAgentCode,
            newAgentCode: queryParam,
          });
        } else if (hashAgentCode === queryParam) {
                window.location.href = `${routes.DASHBOARD}`
        }
      } else {
                window.location.href = `${routes.DASHBOARD}`
      }

            }else{
          window.location.href = `${AppConstants.redirect_url}`

            }
        } catch (error: any) {
            if (error && error.status === 404) {
                window.location.href = '/profile-not-found'
            }
        }
    };
};
 setTemporaryQueryParams = async () => {
  const queryParam = new URLSearchParams(window.location.search).get('agent');
  // const tokenQueryParam = new URLSearchParams(window.location.search).get('id');

  try {
    const params = {
      app: "my",
      sub_domain: `${process.env.REACT_APP_BASE_URL}`,
      context: {"queryParam":queryParam},
      redirect_url: `${process.env.REACT_APP_MY_URL}`,
    };

    const response = await service.HousingProject.setTemporary(
      params
    );
  
    if (response.status === 200) {
      window.open(
        `${process.env.REACT_APP_SSO_URL}/authentication/init/${response?.data?.data?.token}`,
        '_blank'
      );
    }
  } catch (error) {
    console.error("Error during investment request:", error);
  }
};


getTemporaryQueryParams= async (token:string) => {
  try {
    const response = await service.HousingProject.temporary(token);
    if (response) {
        this.props.dispatch(this.getProfile(response?.data?.data?.context?.queryParam));

      // return response;
    }
  } catch (error) {
    // throw error;
  }
};
 updateProfile = (hashAgentCode?:string) => {
   const { newAgentCode } = this.state;
   const referralCodeSchema = yup.object({
    newAgentCode: yup
      .string()
      .transform((value) => value?.trim() || "")
      .test(
        "optional-exact-length",
        "کد معرف باید دقیقاً ۶ کاراکتر باشد ",
        (value) => {
          if (!value) return true;
          return value.length === 6;
        }
      ),
  });
    return async  (dispatch: any) => {

  try {
    this.setState({ loadingUpdate: true })
    await referralCodeSchema.validate({ newAgentCode }, { abortEarly: false });

    const response = await service.User.updateProfile({
      agent_code:hashAgentCode
    }); 

    if (response) {

      if (response?.status === 200) {
        dispatch(userData(response?.data?.data));
    this.setState({ loadingUpdate: false })
      window.location.href = `${routes.DASHBOARD}`

      } else {
        toast.error(response?.data?.message || "خطایی رخ داده است");
        this.setState({ loadingUpdate: false })

      }

    }
  } catch (err: any) {
    this.setState({ loadingUpdate: false })
    toast.error(err?.message)
    // this.setState({ error: err.inner })
  }
};
};
 
async checkReferralCode(queryParam?:string) {
      try {

        const response = await service.AgentCode.create({
          agent_code: queryParam,
        });
        return !!response?.data?.data?.agent_code;
      } catch (error) {
        return false; 
      }
        
  }
  
}
export default PreviewController;